import React from "react";
import { motion } from "framer-motion";

// Original geometric "RG" mark — interlocking node representing thinking, systems & connection.
export const Logo = ({ size = 40, animate = false, className = "" }) => {
  const draw = {
    hidden: { pathLength: 0, opacity: 0 },
    visible: (i = 0) => ({
      pathLength: 1,
      opacity: 1,
      transition: { pathLength: { duration: 1.1, delay: i * 0.25, ease: [0.16, 1, 0.3, 1] }, opacity: { duration: 0.2, delay: i * 0.25 } },
    }),
  };
  const Comp = animate ? motion.path : "path";
  const CircleComp = animate ? motion.circle : "circle";
  const motionProps = (i) => (animate ? { variants: draw, initial: "hidden", animate: "visible", custom: i } : {});

  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} aria-label="Rui Guimarães logo">
      {/* hexagonal system frame */}
      <Comp
        d="M24 3 L40.5 12.5 L40.5 35.5 L24 45 L7.5 35.5 L7.5 12.5 Z"
        stroke="#FF6A00" strokeWidth="1.6" strokeLinejoin="round" {...motionProps(0)}
      />
      {/* R */}
      <Comp d="M17 15 L17 33 M17 15 L24 15 Q28 15 28 20 Q28 24 24 24 L17 24 M22 24 L29 33"
        stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" {...motionProps(1)} />
      {/* connection nodes */}
      <CircleComp cx="40.5" cy="12.5" r="2.2" fill="#FF6A00" {...(animate ? { initial: { scale: 0 }, animate: { scale: 1 }, transition: { delay: 1.2, type: "spring", stiffness: 300 } } : {})} />
      <CircleComp cx="7.5" cy="35.5" r="2.2" fill="#FF6A00" {...(animate ? { initial: { scale: 0 }, animate: { scale: 1 }, transition: { delay: 1.35, type: "spring", stiffness: 300 } } : {})} />
    </svg>
  );
};

export const Wordmark = ({ className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <Logo size={30} />
    <span className="font-heading font-extrabold tracking-tight text-[15px] leading-none">
      Rui<span className="text-flame">.</span>Guimarães
    </span>
  </div>
);
